import Router from './Router'

const App = (props) => <Router>{props.children}</Router>

export default App
